import { ROUTES } from '../constants';

const DEFAULT_MARKETING_HOSTS = ['strat-edu.com', 'www.strat-edu.com'];

function marketingHosts(): string[] {
  const raw = process.env['REACT_APP_MARKETING_HOSTS'];
  if (!raw?.trim()) return DEFAULT_MARKETING_HOSTS;
  return raw.split(',').map(h => h.trim().toLowerCase()).filter(Boolean);
}

export function getAppOrigin(): string {
  const configured = process.env['REACT_APP_APP_URL']?.replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    }
    if (hostname.startsWith('app.')) {
      return `${protocol}//${hostname}`;
    }
    const apex = hostname.replace(/^www\./, '');
    return `${protocol}//app.${apex}`;
  }
  return '';
}

export function isMarketingHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return marketingHosts().includes(host);
}

export function isAppHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') {
    return !marketingHosts().includes(host);
  }
  const appOrigin = getAppOrigin();
  if (appOrigin) {
    try {
      return new URL(appOrigin).hostname.toLowerCase() === host;
    } catch {
      /* fall through */
    }
  }
  return host.startsWith('app.');
}

export function appUrlForPath(path: string): string {
  const base = getAppOrigin();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}

export function signInUrl(): string {
  return appUrlForPath(ROUTES.LOGIN);
}

export function dashboardUrl(): string {
  return appUrlForPath(ROUTES.DASHBOARD);
}
